import {Injectable} from '@angular/core';
import {GlobalService} from "./global.service";
import {NzModalService} from "ng-zorro-antd";
import {CookieService} from "ngx-cookie-service";
import {HttpCommonService} from "./http-common.service";
import {Router} from "@angular/router";

@Injectable()
export class LoginService {
  constructor(private globalService: GlobalService,private cookieService: CookieService,
              private showConfirm:NzModalService, private http: HttpCommonService,
              private router: Router) {

  }

  /**
   * 退出登录
   */
  loginOut() {
    let thiss = this;
    this.showConfirm.confirm({
      title: '',
      content: '您是否要退出？',
      onOk() {
        thiss.http.get("/auth/jwt/logout").subscribe(data => {
          //thiss.cookieService.delete("auth-token");
          thiss.globalService.checkLoginState();
          thiss.globalService.deleteLocalStorage();
          thiss.globalService.isLoginedUser = false;
          thiss.globalService.setKey("countShow", false);
          thiss.router.navigate(['']);
        });
      },
      onCancel() {
      }
    });



  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/login.service.ts